export const styles = {
  recipientDetails: {
    container: "p-3",
    grid: "grid grid-cols-6 items-center",
    leftCol: "flex flex-col gap-4 col-span-4 ml-2",
    row: "flex items-center gap-1",
    rowWide: "flex gap-1",
    rightCol: "flex justify-end items-end gap-5 mr-3 col-span-2",
    kycBox: "justify-center items-center border p-3 rounded-lg",
    buttonBase: "p-2 hover:bg-blue-50 border h-8 w-full rounded-lg",
    sendCopyButtonText: "flex items-center gap-2",
    primaryBtn: "p-2 hover:bg-blue-600 rounded-lg min-w-[10rem]",
    deleteBtn: "p-2 hover:bg-red-50 mt-1 rounded-lg min-w-[10rem]",
    deleteBtnText: "flex items-center justify-center gap-1",
  },
};
